
import { initPromise } from '../i18n';

// Wait for `i18next`'s init to complete to ensure it's working correctly and
// to avoid some warnings.
export default () => initPromise;
